import { useCallback, useEffect, useState } from 'react';
import { learningApi } from '../api/learning';
import type { VerbPhraseCourse } from '../types/api';

export function useVerbPhraseCourse(enabled: boolean) {
  const [course, setCourse] = useState<VerbPhraseCourse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!enabled) return null;
    setLoading(true);
    try {
      const payload = await learningApi.verbPhraseCourse();
      setCourse(payload);
      setError(null);
      return payload;
    } catch {
      setError('Kunne ikke hente verbkurset akkurat nå.');
      return null;
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setCourse(null);
      return;
    }
    void refresh();
  }, [enabled, refresh]);

  return { course, loading, error, refresh };
}
